import React from 'react';
import { UserModel } from '../../../entities/user.entity';
import * as chartService from '../../../services/chartService';
import { useGetIdentity } from 'react-admin';

const useTop5Player = (params: chartService.FilterParam) => {
  const [data, setData] = React.useState({} as any);
  const [loading, setLoading] = React.useState(false);
  const { data: userData } = useGetIdentity();
  const user = userData as UserModel;
  const { agencyId, gameIds, fromTime, toTime } = params?.filter ?? {};

  React.useEffect(() => {
    if (user) {
      setLoading(true);
      chartService
        .getTop5Player({ filter: { agencyId, gameIds, fromTime, toTime } })
        .then((response: any) => {
          setData(response.data);
          setLoading(false);
        });
    }
  }, [user, agencyId, gameIds, fromTime, toTime]);

  return {
    data,
    loading,
  };
};

export default useTop5Player;
